import axios from 'axios';
import analytics from 'shared/utility/analytics';

const getSettings = (callback) => {
  axios({
    method: 'get',
    url: '/orv/tool-settings',
  }).then((response) => {
    const { uaCode } = response.data;
    analytics.init('G-TPYEPBXRNK', uaCode);
    callback(response);
  }).catch(err => console.error(err));
};

export default getSettings;

